import { RecordsColumnsEnum } from '../records.component.model';

export interface ColumnPreferenceData {
  key: string;
  label: string;
  checked: boolean;
}

export const prefixLabelRoute: string = 'application.records.table.columns.';

export const baseItems: ColumnPreferenceData[] = [
  { key: RecordsColumnsEnum.creationDate, label: prefixLabelRoute + RecordsColumnsEnum.creationDate, checked: true },
  { key: RecordsColumnsEnum.cckNumber, label: prefixLabelRoute + RecordsColumnsEnum.cckNumber, checked: true },
  {
    key: RecordsColumnsEnum.unreadMessages,
    label: prefixLabelRoute + RecordsColumnsEnum.unreadMessages,
    checked: true
  },
  { key: RecordsColumnsEnum.prospectName, label: prefixLabelRoute + RecordsColumnsEnum.prospectName, checked: true },
  {
    key: RecordsColumnsEnum.siclidProductCode,
    label: prefixLabelRoute + RecordsColumnsEnum.siclidProductCode,
    checked: true
  },
  { key: RecordsColumnsEnum.insurances, label: prefixLabelRoute + RecordsColumnsEnum.insurances, checked: true },
  { key: RecordsColumnsEnum.statusSigned, label: prefixLabelRoute + RecordsColumnsEnum.statusSigned, checked: true },
  { key: RecordsColumnsEnum.subStatus, label: prefixLabelRoute + RecordsColumnsEnum.subStatus, checked: true },
  {
    key: RecordsColumnsEnum.rvDerogationStatus,
    label: prefixLabelRoute + RecordsColumnsEnum.rvDerogationStatus,
    checked: true
  },
  {
    key: RecordsColumnsEnum.brand,
    label: prefixLabelRoute + RecordsColumnsEnum.brand,
    checked: false
  },
  { key: RecordsColumnsEnum.duration, label: prefixLabelRoute + RecordsColumnsEnum.duration, checked: false },
  {
    key: RecordsColumnsEnum.instalmentAmountWithInsurances,
    label: prefixLabelRoute + RecordsColumnsEnum.instalmentAmountWithInsurances,
    checked: false
  },
  { key: RecordsColumnsEnum.category, label: prefixLabelRoute + RecordsColumnsEnum.category, checked: false },
  { key: RecordsColumnsEnum.pricingLabel, label: prefixLabelRoute + RecordsColumnsEnum.pricingLabel, checked: false },
  {
    key: RecordsColumnsEnum.residualValueAmount,
    label: prefixLabelRoute + RecordsColumnsEnum.residualValueAmount,
    checked: false
  },
  { key: RecordsColumnsEnum.webStoreId, label: prefixLabelRoute + RecordsColumnsEnum.webStoreId, checked: false },
  { key: RecordsColumnsEnum.webStoreName, label: prefixLabelRoute + RecordsColumnsEnum.webStoreName, checked: false },
  { key: RecordsColumnsEnum.userLogin, label: prefixLabelRoute + RecordsColumnsEnum.userLogin, checked: false },
  {
    key: RecordsColumnsEnum.vehicleDeliveryDate,
    label: prefixLabelRoute + RecordsColumnsEnum.vehicleDeliveryDate,
    checked: false
  },
  {
    key: RecordsColumnsEnum.overdraftAmount,
    label: prefixLabelRoute + RecordsColumnsEnum.overdraftAmount,
    checked: false
  },
  {
    key: RecordsColumnsEnum.instalmentAmountWithoutInsurances,
    label: prefixLabelRoute + RecordsColumnsEnum.instalmentAmountWithoutInsurances,
    checked: false
  },
  { key: RecordsColumnsEnum.used, label: prefixLabelRoute + RecordsColumnsEnum.used, checked: false },
  { key: RecordsColumnsEnum.model, label: prefixLabelRoute + RecordsColumnsEnum.model, checked: false },
  { key: RecordsColumnsEnum.version, label: prefixLabelRoute + RecordsColumnsEnum.version, checked: false },
  {
    key: RecordsColumnsEnum.residualValuePercent,
    label: prefixLabelRoute + RecordsColumnsEnum.residualValuePercent,
    checked: false
  },
  { key: RecordsColumnsEnum.type, label: prefixLabelRoute + RecordsColumnsEnum.type, checked: false },
  {
    key: RecordsColumnsEnum.pfStatusSigned,
    label: prefixLabelRoute + RecordsColumnsEnum.pfStatusSigned,
    checked: false
  },
  {
    key: RecordsColumnsEnum.deliverystatusSigned,
    label: prefixLabelRoute + RecordsColumnsEnum.deliverystatusSigned,
    checked: false
  }
];
